//import { Canvg } from "canvg";

export class FigAnim {

    constructor(targetElem) {

        this.container = targetElem;
        this.frames = targetElem.querySelectorAll('.js-frameanim-frame');

        // timestamp
        this.timestamp = 0;

        // settings
        this.updateRate = 1000 / 60;
        this.lastTime = 0;
        this.elapsedTime = 0;

        // canvas variables
        // this.canvas;

        // fps
        // this.fps = 0;
        // this.accumulatedTime = 0;
        // this.accumulatedFrames = 0;

        // blocks (numCircles * 2 * size must be less than 600 for this example)
        // this.numCircles = 8;
        // this.circles = [];
        // this.velocity = 3;
        // this.size = 30;

        //this.playing = false;

        // frame animation
        this.intervalId_1;
        //this.intervalId_2;
        //this.intervalId_reverse;
        this.nextIndex = 0;
        this.maxFrame = 0;
        //this.expandAnimMode = 0;
        this.frameDirection = 1;
    }

    play(){
        console.log(this.container);
        //this.frames[0].classList.add('is-show');

        this.maxFrame = this.frames.length - 1;

        if(!this.intervalId_1){
            this.intervalId_1 = setInterval(() => {
                //console.log(`再生: frame=${currentIndex}`);
                //this.frames[this.currentIndex].classList.remove('is-show');

                //次のフレームを計算
                this.frameDirection = 1;
                this.nextIndex = this.nextIndex + this.frameDirection;
                if(this.nextIndex > this.maxFrame){
                    this.nextIndex = this.maxFrame;
                }
                
                //実行
                [].forEach.call(this.frames, (frame) => {
                    frame.classList.remove('is-show');
                });
                this.frames[this.nextIndex].classList.add('is-show');

                if(this.nextIndex == this.maxFrame){
                    clearInterval(this.intervalId_1);
                }
            }, 30);
        }
    }



    // gameLoop() {
    //     this.timestamp = window.performance.now();

    //     // accumulating time and frames for FPS
    //     this.accumulatedTime += this.timestamp - this.lastTime;
    //     this.accumulatedFrames++;
        
    //     // keeping track of passed time
    //     this.elapsedTime += this.timestamp - this.lastTime;
    //     this.lastTime = this.timestamp;
        
    //     // calculating the fps
    //     if (this.accumulatedTime >= 1000) {
    //         this.fps = this.accumulatedFrames;
    //         this.accumulatedFrames = 0;
    //         this.accumulatedTime -= 1000;
    //     }
        
    //     // logic update - if machine slow then do multiple steps to catcanvasHeight up
    //     while (this.elapsedTime >= this.updateRate) {
    //         this.update();
    //         this.elapsedTime -= this.updateRate;
    //     }
        
    //     // render update - render every possible frame
    //     this.render();	
        
    //     // repeat loop
    //     //requestAnimationFrame(this.gameLoop);
    //     window.requestAnimationFrame(() => this.gameLoop());
    // }

    // update() {
    //     for (let i = 0; i < this.numCircles; i++) {
    //         let circle = this.circles[i];
    //         circle.x += circle.vx;
    //         circle.y += circle.vy;

    //         // canvasの中心からの距離: 円形の壁
    //         const distance = Math.sqrt(Math.pow(circle.x - 0.5*(this.canvasWidth), 2) + Math.pow(circle.y - 0.5*(this.canvasHeight), 2));
    //         if(distance >= (0.5*this.canvasWidth - this.size)){
    //             circle.vy *= -1;
    //             circle.vx *= -1;
    //         }

    //         // collision check
    //         for (let j = i + 1; j < this.numCircles; j++) {
    //             let circle2 = this.circles[j];
    //             let dx = circle2.x - circle.x;
    //             let dy = circle2.y - circle.y;
    //             let dist = Math.sqrt(dx * dx + dy * dy);
    //             if (dist < (this.size + this.size)) {
    //                 // angles
    //                 let angle = Math.atan2(dy, dx);
    //                 let sin = Math.sin(angle);
    //                 let cos = Math.cos(angle);

    //                 // circle1 perpendicular velocities
    //                 let vx1 = (circle.vx * cos + circle.vy * sin);
    //                 let vy1 = (circle.vy * cos - circle.vx * sin);
                    
    //                 // circle2 perpendicular velocities
    //                 let vx2 = (circle2.vx * cos + circle2.vy * sin);
    //                 let vy2 = (circle2.vy * cos - circle2.vx * sin);
                    
    //                 // swapping the x velocity (y is parallel so doesn't matter)
    //                 // and rotating back the adjusted perpendicular velocities
    //                 circle.vx = vx2 * cos - vy1 * sin;
    //                 circle.vy = vy1 * cos + vx2 * sin;
    //                 circle2.vx = vx1 * cos - vy2 * sin;
    //                 circle2.vy = vy2 * cos + vx1 * sin;
    //             }
    //         }
    //     }	
    // }

    // render() {
    //     this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);

    //     // circles
    //     for (let i = 0; i < this.numCircles; i++) {
    //         this.ctx.beginPath();
    //         this.ctx.arc(this.circles[i].x, this.circles[i].y, this.size, 0, 2 * Math.PI, true);
    //         this.ctx.fillStyle = 'transparent';
    //         this.ctx.strokeStyle = 'rgba(255,255,255,0.9)';
    //         this.ctx.lineWidth = 1;
    //         this.ctx.stroke();
    //         this.ctx.fill();
    //     }
    // }


    // init(){
    //     this.body = document.getElementsByTagName('body')[0];
    //     this.html = document.getElementsByTagName('html')[0];

    //     //canvas
    //     this.canvas = document.getElementById('conceptCanvas');
    //     this.ctx = this.canvas.getContext('2d');
    //     this.canvasWidth = this.canvas.width;
    //     this.canvasHeight = this.canvas.height;
    // }

    // play(){
    //     if(this.playing !== true){

    //         this.playing = true;

    //         //console.log('canvas balls play');
    //         //create the circles
    //         for (let i = 0; i < this.numCircles; i++) {
    
    //             //円の中でランダム
    //             // const randomAngle = Math.random() * 2 * Math.PI; // 0〜2πのランダムな角度を生成
    //             // const randomRadius = Math.random() * (this.canvasWidth/2 - this.size);// 0〜半径のランダムな距離を生成
    //             // const randomX = this.canvasWidth/2 + randomRadius * Math.cos(randomAngle); // x座標を計算
    //             // const randomY = this.canvasHeight/2 + randomRadius * Math.sin(randomAngle); // y座標を計算
    
    //             //console.log(randomX + ', ' + randomY);
    //             const randomX = [179,332,398,277,288,318,460,129];
    //             const randomY = [213,328,487,399,182,263,173,430];
    
    //             this.circles.push({
    //                 x: randomX[i],
    //                 y: randomY[i],
    //                 //x: 2 * this.size * i,
    //                 //y: Math.random() * (this.canvasHeight - 2 * this.size) + this.size,
    //                 vx: (Math.random() - 0.5) * this.velocity * 2,
    //                 vy: (Math.random() - 0.5) * this.velocity * 2
    //             });
    //         }
    
    //         this.timestamp = window.performance.now();
    //         this.startTime = window.performance.now();
    //         //requestAnimationFrame(this.gameLoop);
    //         window.requestAnimationFrame(() => this.gameLoop());
    
    
    //         //this.ballExpandAnim();
    //     }

    // }


    // setExpandAnimMode(num){
    //     this.expandAnimMode = num;
    // }


    //frame anim 初期化
    // playExpandAnimInit(){
    //     let container = document.getElementById('ball-expand');
    //     let boxes = container.querySelectorAll('.ball-expand__frame');
    //     this.maxFrame = boxes.length - 1;

    //     if(!this.intervalId_1){
    //         this.intervalId_1 = setInterval(() => {
    //             //console.log(`再生: frame=${currentIndex}`);
    //             //boxes[this.currentIndex].classList.remove('is-show');

    //             //一時停止frame
    //             let pauseFrame = 34;

    //             //次のフレームを計算
    //             //console.log(`this.expandAnimMode=${this.expandAnimMode}`);
    //             if(this.expandAnimMode == 0){
    //                 this.frameDirection = -1;
    //                 this.nextIndex = this.nextIndex + this.frameDirection;
    //                 if(this.nextIndex < 0){
    //                     this.nextIndex = 0;
    //                 }
    //             }else if(this.expandAnimMode == 1){
    //                 if((this.nextIndex + this.frameDirection) < (pauseFrame)){
    //                     this.frameDirection = 1;
    //                 }
    //                 if((this.nextIndex + this.frameDirection) > (pauseFrame + 24)){
    //                     this.frameDirection = -1;
    //                 }
    //                 this.nextIndex = this.nextIndex + this.frameDirection;
    //             }else if(this.expandAnimMode == 2){
    //                 //最後まで
    //                 this.frameDirection = 1;
    //                 this.nextIndex = this.nextIndex + this.frameDirection;
    //                 if(this.nextIndex > this.maxFrame){
    //                     this.nextIndex = this.maxFrame;
    //                 }
    //             }


    //             //実行
    //             [].forEach.call(boxes, (frame) => {
    //                 frame.classList.remove('is-show');
    //             });
    //             boxes[this.nextIndex].classList.add('is-show');
    //         }, 30);
    //     }
    // }
}